<template>
  <v-app id="inspire">
    <div class="text-center">
    <v-dialog
    persistent
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="red lighten-2"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Click Me
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2">
          READ ME
        </v-card-title>

        <v-card-text>
          This project is for demonstration purposes only.
          This GUI (Graphical User Interface) was designed by James O'Neill for use at the ASDEX Upgrade fusion reactor in the Max Planck Institute for Plasma Physics, Germany.
        </v-card-text>
        <v-card-text>
          The real GUI is connected to a diagnostic system for the reactor, which uses something called the "Motional Stark Effect" to gain information about the inside of the reactor.
        </v-card-text>
        <v-card-text>
          This is a demo version and is not connected to the live backend.
        </v-card-text>
        <v-card-text>
          This grid represents a switchboard of fibre optic cables. Each connection leads to one of the two devices. 
        </v-card-text>
        <v-card-text> PMT - Photomultiplier Tube</v-card-text>
        <v-card-text> PY - Polychromator</v-card-text>
        <v-card-text> Both devices process the signal coming from the reactor chamber</v-card-text>
        
        <v-card-text>Clicking on a switchboard position allows you to edit the properties of the connected devices to change the experiment parameters.</v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
    <BackendSimulator></BackendSimulator>
    <v-navigation-drawer
      v-model="drawer"
      app
    >
      <v-list dense>
        <router-link to="/">
          <v-list-item link>
            <v-list-item-action>
              <v-icon>mdi-grid</v-icon>
            </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Switchboard</v-list-item-title>
              </v-list-item-content>
          </v-list-item>
        </router-link>
        <router-link to="/status">
          <v-list-item link>
            <v-list-item-action>
              <v-icon>mdi-home-analytics</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Status</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      color="indigo"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Motional Stark Effect GUI
        <span v-if="$route.path == '/'">- Switchboard</span>
        <span v-if="$route.path == '/status'">- Status</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <a class="white--text" href="../../index">
      <v-btn icon>
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </a>
    
    <a class="white--text" href="https://github.com/Jamesdavidoneill/mseGUI">
      <v-btn icon>
        <v-icon>mdi-github</v-icon>
      </v-btn>
    </a>
    </v-app-bar>

    <v-main>
      <router-view/>
    </v-main>
    <v-footer
      color="indigo"
      app
    >
      <span class="white--text">&copy; {{ new Date().getFullYear() }}</span>
      <a class="white--text" href="../../index"> Back to portfolio</a>
    </v-footer>
  </v-app>
</template>

<script>
  import BackendSimulator from './components/BackendSimulator'
  export default {
    props: {
      source: String,
    },
    data: () => ({
      drawer: null,
      dialog: true
    }),
    components:{
      BackendSimulator
    }
  }
</script> {
  color: blue;
}
<style>
  a{
    text-decoration: none;
  }
</style>